import TableContainer from '@mui/material/TableContainer';
import {
  default as MuiTable,
  type TableProps as MuiTableProps,
} from '@mui/material/Table';

export interface TableProps extends MuiTableProps {
  wrapperClassName?: string;
}

export default function Table({ wrapperClassName, ...props }: TableProps) {
  return (
    <TableContainer className={wrapperClassName}>
      <MuiTable stickyHeader {...props} />
    </TableContainer>
  );
}

export { default as TableBody, type TableBodyProps } from './TableBody';
export { default as TableCell, type TableCellProps } from './TableCell';
export { default as TableHead, type TableHeadProps } from './TableHead';
export {
  default as TableHeadCell,
  type TableHeadCellProps,
} from './TableHeadCell';
export {
  default as SortableHeadCell,
  type SortableHeadCellProps,
} from './SortableHeadCell';
export {
  default as TableHeadRow,
  type TableHeadRowProps,
} from './TableHeadRow';
export { default as TableRow, type TableRowProps } from './TableRow';
export { default as OptionsCell, type OptionsCellProps } from './OptionsCell';
export { default as SkeletonRow, type SkeletonRowProps } from './SkeletonRow';
export {
  default as SkeletonRows,
  type SkeletonRowsProps,
} from './SkeletonRows';
